import request from '@/utils/http';
const EXPORT_TIMEOUT = 1000 * 3600 * 24;
export const getTracking = (params) => {
    return request({
        url: `/api-lots/transport/search`,
        method: 'get',
        params
    });
};

export const exportListData = params => {
    request.defaults.timeout = EXPORT_TIMEOUT;
    return request({
        url: `api-lots/transport/tracking/export`,
        method: 'get',
        params: params
    }).then(res => res);
};